import { NgModule } from '@angular/core';
import { ToastComponent } from './component/toast.component';
import { AccredibleToastService } from './service/toast.service';

@NgModule({
  declarations: [ToastComponent],
  providers: [AccredibleToastService],
})
export class AccredibleToastModule {}
